<template>
  <div class="replace-toast">
    <img
      class="icon"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a61935b7e211bfbe9de25fdb12ef1195.webp"
      alt=""
    />
    <div class="title">确定更换食谱吗？</div>
    <div class="text">{{ text }}</div>
    <div class="btn-list">
      <div class="btn-item" @click="bindCancel">暂不更换</div>
      <div class="btn-item btn-item-active" @click="bindConfirm">确定</div>
    </div>
    <div class="close iconfont icon-cha" @click="bindCancel"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindCancel() {
      this.$emit('cancel')
    },
    bindConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
.replace-toast {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 294px;
  padding: 0px 20px 20px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 12px;
  .icon {
    width: 156px;
    height: 156px;
    margin: 0 auto 3px;
  }
  .title {
    font-weight: bold;
    font-size: 18px;
    color: #303038;
    line-height: 26px;
    margin-bottom: 8px;
  }
  .text {
    font-size: 13px;
    color: rgba(48, 48, 56, 0.7);
    line-height: 21px;
    margin-bottom: 25px;
  }
  .btn-list {
    display: flex;
    align-content: center;
    justify-content: space-between;
    .btn-item {
      width: 122px;
      height: 44px;
      box-sizing: border-box;
      border-radius: 22px;
      text-align: center;
      line-height: 42px;
      border: 1px solid rgba(48, 48, 56, 0.7);
      font-size: 16px;
      color: rgba(48, 48, 56, 0.7);
    }
    .btn-item-active {
      background: linear-gradient(270deg, #373a56 0%, #565e7a 100%);
      font-weight: bold;
      color: #ffffff;
    }
  }
  .close {
    border: 1px solid #fff;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: -54px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }
}
</style>
